<template> 
    <div>
        <div class="align" v-if="isVisible()">
            <button v-if="!isDocCom" class="btn btn-file " >
                <i class='fa fa-upload icon-custom'></i>
                    <input 
                    type="file"
                    ref="file"
                    @change = "ajouterFichierDocumentVierge()"                 
                >           
            </button>
            <Transition name = fade>
                <div class="align" v-if="!(this.doc.fichier == '')">
                    <button class = "btn btn-file " 
                        @click="telechargerFichier(doc.fichier_url)" 
                        title="Télécharger">                   
                        <i class="fa fa-download icon-custom icons" ></i> 
                    </button>
                    <button class = "btn btn-file" 
                        @click="ouvrirWebViewer(doc.fichier_url,true)"
                        title="Voir"
                        >                   
                        <i class="fa fa-eye icon-custom icons" ></i> 
                    </button>
                    <!-- <button class = "btn   btn-file btn-delete" 
                            @click="supprimerDocument()"
                            title="Supprimer"
                            >                   
                            <i class="fa fa-trash icon-custom icons" ></i> 
                            
                    </button> -->
                </div>
            </Transition>
        </div>
        <div class="stella"  v-if="!isVisible() && !isDocCom">
            <div v-if="isUploadClient">
                <div v-if="!chargementImport" class="add-document-section">
                    <div class="add-document-container add-document-container-blue">
                        <div class="add-document-icon add-document-icon-blue">
                            <i class="fa fa-plus"></i>
                        </div>
                        <div class="add-document-text">
                            <p class="add-document-title">Téléversements libres</p>
                            <p class="add-document-subtitle">Ajoutez des documents complémentaires ou non présents dans la liste ci-dessus</p>
                        </div>
                        <button class = "btn btn-file btn-add-doc" style="max-width: 220px !important;">
                            Sélectionner les fichiers
                            <input
                                multiple
                                type="file"
                                ref="files"
                                @change = "ajouterNouveauDocumentAvecFichier()"                 
                            >                                              
                        </button>
                    </div>
                </div>
                <div v-if="chargementImport" class="load">
                    <div class="loader"></div>
                    en cours d'importation
                </div>
            </div>
            <!-- <div v-if="!isUploadClient && !isDocCom  ">
                <div v-if="!click">
                    <div v-if="!openInput" class="add-document-section">
                        <div class="add-document-container add-document-container-blue">
                            <div class="add-document-icon add-document-icon-blue">
                                <i class="fa fa-plus"></i>
                            </div>
                            <div class="add-document-text">
                                <p class="add-document-title">Document personnalisé</p>
                                <p class="add-document-subtitle">Ajoutez un document dont la catégorie ne figure pas dans la liste ci-dessus</p>
                            </div>
                            <button v-if="!chargementImport" 
                                class = "btn btn-file btn-add-doc" 
                                @click = "clickevent()" >
                                Continuer
                            </button>
                        </div>
                        <div v-if="chargementImport" class="load">
                            <div class="loader"></div>
                            en cours d'importation
                        </div>  
                    </div>
                    <div v-if = "openInput" class="import-section">
                        <div class="import-header">
                            <h4>Importer un fichier</h4>
                            <button
                                class = "close-btn"
                                @click = "clickevent()" >
                                <i class='fa fa-times'></i>
                            </button>
                        </div>
                        <button  class="btn btn-file btn-import" >
                            Sélectionner le fichier
                            <input 
                            type="file"
                            ref="filebis"
                            @change = "ajouterNouveauDocumentAvecFichierPiece()"                 
                            >           
                        </button>
                    </div>          
                </div>
                <div  v-if="click" class="select-section">
                    <label class="select-label">Nom du document :</label>
                    <select class="select "  @change="onChange($event)" >
                        <option value="0">Choisir un nom de document:</option>
                        <option  v-for="piece in listePiece" :key="piece.id" :value="piece.id" >{{piece.lib}}</option>
                    </select>
                </div>           
            </div> -->
        </div>     
    </div>           
</template>

<script>
    import api from '@/api'
    export default { 
        name:'SimpleUpload',
        props:{
            doc:Object,
            show:Boolean,
            folderId:Number,
            isDocCom:Boolean,
            isUploadClient:Boolean
        },
        data(){
            return{
                file:"",
                files:[],
                publicPath: process.env.BASE_URL,
                chargementImport:false ,
                listePiece:[],
                click:false ,
                pieceId:0 ,
                openInput:false
            }
        }, 
        mounted(){
            const { dossierId } = this.$route.params
            api.listerPieceLib(dossierId).then((response)=>{
                    this.listePiece = response.data
            })      
        },       
        methods:{
            //méthode pour ajouter un fichier à un document existant en passant par l'api
            ajouterFichierDocumentVierge(){
                this.chargement(true,this.doc.id)
                this.file = "";
                this.file = this.$refs.file.files[0];
                const { dossierId } = this.$route.params
                const documentId = this.doc.id;
                const documentFolderId = this.doc.document_folder   
                api.fichierUploader(dossierId,documentId,documentFolderId,this.file,0).then((response) => { 
                    this.chargement(false,this.doc.id)             
                    this.doc.fichier = response.data.fichier.nom
                    this.doc.fichier_url = response.data["document"]["fichier_url"]
                    this.ouvrirWebViewer(this.doc.fichier_url,false )
                    this.doc.document_statut = response.data["document"]["document_statut"]                           
                    this.sendStatutFolder(response.data["list_folder"])                                        
                })
            },
            //méthode pour crée un document et associer le fichier à celui-ci
            ajouterNouveauDocumentAvecFichier(){ 
                this.files = [];
                this.files = this.$refs.files.files;   
                const { dossierId } = this.$route.params 
                let i = 0;
                while(i<this.files.length){
                    this.chargementImport=true;
                    api.fichierUploader(dossierId,0,this.folderId,this.files[i],0).then((response) => { 
                        this.chargementImport=false;                     
                        this.afficherDocument(response.data["document"])
                        this.sendStatutFolder(response.data["list_folder"])                                              
                    })   
                    i++
                }
                
            },
            ajouterNouveauDocumentAvecFichierPiece(){
                this.click = false;
                this.openInput= false;
                this.file = "";
                this.file = this.$refs.filebis.files[0];
                const { dossierId } = this.$route.params 
                this.chargementImport=true;
                api.fichierUploader(dossierId,0,this.folderId,this.file,this.pieceId).then((response) => {    
                    this.afficherDocument(response.data["document"])
                    this.sendStatutFolder(response.data["list_folder"])  
                    this.chargementImport=false;                                             
                })            
            },
            afficherDocument(document){
                this.$root.$emit('afficherDocument',document)              
            },
            sendStatutFolder(listFolder){
                this.$root.$emit('sendStatutFolder',listFolder)
            },
            isVisible(){
                return this.show
            },
            telechargerFichier(fichierUrl) {        
              window.open(fichierUrl);
            },
            ouvrirWebViewer(fichierUrl,afficher){
                this.$root.$emit('ouvrirWebViewer',fichierUrl,afficher)
            },
            chargement(chargement,docId){
                this.$root.$emit('chargement',chargement,docId)
            },
            clickevent(){
                this.click =!this.click
            },
            onChange(event) {
                this.clickevent()
                
                this.pieceId=event.srcElement.value
                this.openInput = true
            },
            supprimerDocument() {
                if (confirm('Êtes-vous sûr de vouloir supprimer ce document ?')) {
                    this.chargement(true, this.doc.id)
                    const { dossierId } = this.$route.params
                    api.fichierSupprimer(dossierId, this.doc.id).then((response) => {
                        this.doc.fichier = ''
                        this.sendStatutFolder(response.data["list_folder"])
                        this.chargement(false, this.doc.id)
                        this.$root.$emit('afficherDocument', { message: 'Document supprimé avec succès' })
                    }).catch((error) => {
                        console.error('Erreur lors de la suppression:', error)
                        this.chargement(false, this.doc.id)
                    })
                }
            }
            
        }
    }
</script>

<style  lang="scss" scoped>
    @import "../assets/scss/_colors.scss";

    .stella{
        margin-top: 10px;
    }
    .load{
        display: flex;
        text-align: center;
        
    }
    .loader {
        border: 11px solid #f3f3f3;
        border-radius: 50%;
        border-top: 11px solid #3498db;
        width: 39px;
        height: 39px;
        -webkit-animation: spin 1s linear infinite; /* Safari */
        animation: spin 1s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
    }

    .btn {
        min-width: 50px;
        height: 46px !important;
        border-radius: 5px !important;
        padding: 0 20px;
        text-transform: none !important;
        color: #2196f3;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    
    .btn-file {
        position: relative;
        overflow: hidden;
        border: none;
        background: #2196f3;
        display: inline-block;
        font-weight: 600;
        letter-spacing: 0.3px;
        color: #FFFFFF;
    }
    
    .btn-file:hover {
        background-color: #1976D2;
        color: #FFFFFF;
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px rgba(33, 150, 243, 0.4);
    }
    
    .btn-file:active {
        background-color: #1565C0;
    }
    
    .btn-file-green {
        background: #81C784;
    }
    
    .btn-file-green:hover {
        background-color: #66BB6A;
        box-shadow: 0px 4px 12px rgba(129, 199, 132, 0.4);
    }
    
    .btn-file-green:active {
        background-color: #56A367;
    }
    
    .btn-file.btn-delete {
        background-color: #F44336;
    }
    
    .btn-file.btn-delete:hover {
        background-color: #D32F2F;
        box-shadow: 0px 4px 12px rgba(244, 67, 54, 0.4);
    }
    
    .btn-file.btn-delete:active {
        background-color: #C62828;
    }
    
    .btn-file input[type=file] {
        position: absolute;
        top: 0;
        right: 0;
        min-width: 50px;
        margin-bottom: 5px;
        height: 100%;
        padding: 0 20px;
        text-align: right;
        filter: alpha(opacity=0);
        opacity: 0;
        outline: none;
        background: transparent;
        cursor: pointer;
        display: block;
        width: -webkit-fill-available;
        width: 100%;
        border: none;
        font-size: 16px;
    }
    
    .btn-file input[type=file]::-webkit-file-upload-button {
        display: none;
    }
    
    .btn-file input[type=file]::file-selector-button {
        display: none;
    }
   
    .align{
       display:flex;
       justify-content: center;
       gap:7px;
      
    }
    .icon-custom{
        color: #FFFFFF;
        font-size: 20px;
    }
    
    .btn-file:hover .icon-custom {
        color: #FFFFFF;
    }
    .icon-custom-cross{
        color: #ca2722;
        font-size: 20px;
        border:none;
        margin-right: 10px;
       
       
    }
    .cross{
        border: none;
        background: transparent;
    }
     .icons:hover {
   
    color: aliceblue;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition:  all  1s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
    opacity: 0;
    
    }
    .select{
        // A reset of styles, including removing the default dropdown arrow
        // Additional resets for further consistency
        background-color: transparent;
       
        border-radius: 5px  !important;
        border: 5px solid #D5E8FA;
        padding: 0 1em 0 0;
        margin: 0;
        width: 285px !important;
        font-family: inherit;
        font-size: inherit;
        cursor: inherit;
        line-height: inherit;
        outline: none;
    }
    select::-ms-expand {
    display: none;
    }
    .stella-bis{
        margin-left: 10px;
    }
    
    /* Add document section */
    .add-document-section {
        margin-top: 10px;
    }
    
    .add-document-container {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 20px;
        background-color: #F8F9FB;
        border: 1px solid #E0E8F7;
        border-radius: 8px;
        transition: all 0.2s ease;
    }
    
    .add-document-container:hover {
        background-color: #F0F4FA;
        border-color: #2196F3;
        box-shadow: 0px 2px 8px rgba(33, 150, 243, 0.1);
    }
    
    .add-document-container-green {
        background-color: #F1F8F5;
        border-color: #81C784;
    }
    
    .add-document-container-green:hover {
        background-color: #E8F5F0;
        border-color: #66BB6A;
        box-shadow: 0px 2px 8px rgba(129, 199, 132, 0.1);
    }
    
    .add-document-container-blue {
        background-color: #F8F9FB;
        border-color: #E0E8F7;
    }
    
    .add-document-container-blue:hover {
        background-color: #F0F4FA;
        border-color: #2196F3;
        box-shadow: 0px 2px 8px rgba(33, 150, 243, 0.1);
    }
    
    .add-document-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        background-color: #E3F2FD;
        border-radius: 50%;
        flex-shrink: 0;
    }
    
    .add-document-icon i {
        color: #2196F3;
        font-size: 24px;
    }
    
    .add-document-icon-green {
        background-color: #E8F5E9;
    }
    
    .add-document-icon-green i {
        color: #81C784;
    }
    
    .add-document-icon-blue {
        background-color: #E3F2FD;
    }
    
    .add-document-icon-blue i {
        color: #2196F3;
    }
    
    .add-document-text {
        flex: 1;
    }
    
    .add-document-title {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: #333;
    }
    
    .add-document-subtitle {
        margin: 6px 0 0 0;
        font-size: 13px;
        color: #666;
    }
    
    .btn-add-doc {
        flex-shrink: 0;
        padding: 0 24px !important;
        height: 40px !important;
    }
    
    /* Import section */
    .import-section {
        margin-top: 20px;
        padding: 20px;
        background-color: #F8F9FB;
        border: 1px solid #E0E8F7;
        border-radius: 8px;
    }
    
    .import-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }
    
    .import-header h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    
    .close-btn {
        background: transparent;
        border: none;
        cursor: pointer;
        font-size: 20px;
        color: #999;
        padding: 0;
        width: 24px;
        height: 24px;
        transition: all 0.2s ease;
    }
    
    .close-btn:hover {
        color: #333;
        transform: rotate(90deg);
    }
    
    .btn-import {
        width: 100%;
    }
    
    /* Select section */
    .select-section {
        margin-top: 20px;
        padding: 20px;
        background-color: #F8F9FB;
        border: 1px solid #E0E8F7;
        border-radius: 8px;
    }
    
    .select-label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin-bottom: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    
    .select {
        width: 100%;
    }
    
    @media only screen and (max-width: 767px) {
        
        .loader{
            width: 24px;
            height: 22px;
        }
        
        /* Add document section responsive */
        .add-document-container {
            flex-direction: column;
            gap: 12px;
            padding: 16px;
        }
        
        .add-document-icon {
            width: 40px;
            height: 40px;
        }
        
        .add-document-icon i {
            font-size: 20px;
        }
        
        .add-document-text {
            text-align: center;
            width: 100%;
        }
        
        .add-document-title {
            font-size: 14px;
        }
        
        .add-document-subtitle {
            font-size: 12px;
        }
        
        .btn-add-doc {
            width: 100%;
            padding: 0 16px !important;
        }
        
        /* Import section responsive */
        .import-section {
            padding: 16px;
        }
        
        .import-header h4 {
            font-size: 13px;
        }
        
        /* Select section responsive */
        .select-section {
            padding: 16px;
        }
        
        .select-label {
            font-size: 13px;
        }
        
        .select {
            width: 100%;
            border: 3px solid #D5E8FA !important;
            padding: 8px 10px !important;
        }
        
    }

</style>
